module.exports = __webpack_public_path__ + "img/hr-pipe-ending-right.6ac86265.png";